import axios from 'axios';
import {unescapeHTML} from "../helpers";

export default {
  template: "#vue-job-application-form",
  delimiters: ['${', '}'],
  props: [
    "customer_id",
    "customer_first_name",
    "customer_last_name",
    "customer_email",
    "customer_phone",
    'customer_addresses'
  ],
  data() {
    let phone = ''
    let city = ''
    let province = ''
    if (this.customer_addresses) {
      try {
        const addrs = JSON.parse(unescapeHTML(this.customer_addresses))
        if (addrs && addrs.length > 0) {
          const addr = addrs[0]
          phone = addr.phone
          city = addr.city
          province = addr.province_code || addr.province
        }
      } catch (e) {
      }
    }
    return {
      application_error: false,
      application: {
        customer_id: this.customer_id,
        first_name: this.customer_first_name || '',
        last_name: this.customer_last_name || '',
        email: this.customer_email || '',
        phone: phone,
        city: city,
        province: province,
        store_number: null,
        why_work_here: '',
        preferred_role: '',
        experience: {sporting_goods: null, retail: null, customer_service: null},
        languages: [],
        sports: '',
        availability: '',
        resume: '',
        latitude: null,
        longitude: null,
      },
      submitting: false
    }
  },
  computed: {
    visible_stores() {
      if (!(this.$store.getters.closest_stores && this.$store.getters.closest_stores.stores)) {
        return []
      }
      let stores = this.$store.getters.closest_stores.stores.map(e => {
        return {
          store_number: e.store_number,
          store_name: e.store_name + (e.store_name.toUpperCase().includes(e.city.toUpperCase()) ? '' : `, ${e.city}`),
          city: e.city,
          province: e.province
        }
      })
      if (this.application.province) {
        let stores2 = stores.filter(e => {
          return e.province === this.application.province
        })
        if (stores2.length > 0) {
          return stores2
        }
      }
      return stores
    }
  },
  methods: {
    submit_application(e) {
      if (this.$refs['application_form'].reportValidity()) {
        this.submitting = true
        axios.post('/apps/api/careers', this.application).then(
            resp => {
              this.submitting = false
              this.application_error = false
              window.location.pathname = `${this.$store.getters.locale_uri_prefix}/pages/careers-submission`
            }, err => {
              this.submitting = false
              this.application_error = true
            })
      }
    }
  },
  mounted: function () {
    this.application.languages.push(this.$store.state.lang)
    this.$store.dispatch('getLocation').then(
        success => {
          if (this.$store.getters.favorite_or_closest) {
            this.application.latitude = this.$store.state.location.latitude
            this.application.longitude = this.$store.state.location.longitude
          }
        },
        () => {
        })
  }
}